import React, { lazy } from 'react';
import { useTranslation } from 'react-i18next';
import Styled from './style';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Label = lazy(() => import(`globalcomponents/UI/Label/${layout}`));
const Colors = {
    green: 'green',
    yellow: 'yellow',
    orange: 'orange',
    red: 'red',
    greyLight: '#eaeaea',
    greyDark: '#908e8e',
    blue: '#0097e6',
}

const isUnPoweredViolationList = [
    { label: '0% - 9%', color: Colors.green },
    { label: '10% - 19%', color: Colors.yellow },
    { label: '20%+', color: Colors.red },
];

const accidentItem = [
    { label: '0% - 1%', color: Colors.green },
    { label: '1% - 3%', color: Colors.yellow },
    { label: '3% - 5%', color: Colors.orange },
    { label: '5%+', color: Colors.red },
];

const speedingItem = [
    { label: '0% - 4%', color: Colors.green },
    { label: '5% - 19%', color: Colors.yellow },
    { label: '20%+', color: Colors.red },
];

const fleetItem = (t) => [
    { label: t('scorecard.excellent'), color: Colors.green },
    { label: t('scorecard.good'), color: Colors.yellow },
    { label: t('scorecard.average'), color: Colors.orange },
    { label: t('scorecard.belowAverage'), color: Colors.red },
];

const driverBehaviourItems = (t) => [
    { label: t('scorecard.distractedDriving'), color: Colors.greyLight },
    { label: t('scorecard.speeding'), color: Colors.greyDark },
    { label: t('scorecard.accident'), color: Colors.blue },
];

const RangeInfo = ({
    items = speedingItem,
    fleetScore = false,
    isAccident = false,
    smallGraph= false,
    isDriver = false,
    isUnPoweredViolation = false
}) => {
    const { t } = useTranslation();
    let listItem = isUnPoweredViolation ? isUnPoweredViolationList : fleetScore ? fleetItem(t) : isAccident? accidentItem : isDriver ? driverBehaviourItems(t) : speedingItem;

    return (
        <Styled.ListItem small={smallGraph}>
            {listItem?.map(e => (<Styled.Item small={smallGraph} color={e?.color}><span></span><Label className="noWrap" variant="body1">
                {e?.label}
            </Label></Styled.Item>))}
        </Styled.ListItem>
    );
};

export default RangeInfo;